import React from 'react';
import styled from 'styled-components';
import {OnSurface, HoverColor} from '../../Colors';

const style = {
	SlideButton : styled.button`
        text-decoration: none;
        text-transform: none;
        text-align: center;
        cursor : pointer;
        border-radius : 20px;
        border: none;
        border-radius : 0px;
        background-color : transparent;
        color : ${({color}) => color};

        padding-left : 1rem;
        padding-right : 1rem;
        &:focus{
            outline : 0;
        }
        &:hover{
            background-color : transparent;
            color : ${({OnSurface}) => OnSurface};
        }
	`,
};

const SlideButton = ({
	color=OnSurface,
	hoverColor=HoverColor,
	...props}) => {
	return (
		<style.SlideButton 
			color={color} 
			hoverColor={hoverColor}
			{...props}>{'<<<'}</style.SlideButton>
	);
};

export const EmphasizedSlideButton = styled(SlideButton)`
    &:hover{
        background-color : ${HoverColor};
    }
`;

SlideButton.propTypes = {
};

export default SlideButton;